module.exports = __webpack_public_path__ + "img/9788952236296.831a659d.jpg";